export const gcpMachineTypeCatalogPaths = {
  catalog: (connectionId, params = {}) => {
    const query = new URLSearchParams();
    if (params.zone) query.set('zone', String(params.zone));
    const suffix = query.toString() ? `?${query.toString()}` : '';
    return `/compute/cloud-account-connections/${connectionId}/gcp/machine-types/catalog${suffix}`;
  },
};

function readValue(source, ...keys) {
  if (!source || typeof source !== 'object') return '';
  for (const key of keys) {
    const value = source[key];
    if (value !== undefined && value !== null && String(value).trim()) {
      return String(value).trim();
    }
  }
  return '';
}

export function resolveGcpMachineTypeCatalogAutoLoadTarget({
  account,
  activeTab,
  createDraft = {},
  selectedInstance,
  selectedInstanceDetail,
  catalog,
  error = '',
  loading = false,
  blocked = false,
} = {}) {
  if (!account || account.provider !== 'gcp' || account.status !== 'active') return null;
  if (blocked || loading || error) return null;

  const shouldLoadForTab = activeTab === 'create' || activeTab === 'instances';
  if (!shouldLoadForTab) return null;

  const zone =
    activeTab === 'create'
      ? readValue(createDraft, 'zone')
      : readValue(selectedInstanceDetail, 'zone') || readValue(selectedInstance, 'zone');
  if (!zone) return null;
  if (catalog?.zone === zone && Array.isArray(catalog.machine_types)) return null;

  return { connectionId: account.id, zone };
}
